











import { Component, Vue, Watch } from 'vue-property-decorator';
import FilterBlockComponent from '@/components/SideBar/FilterBlockComponent.vue';
import { FilterGetter } from '@/store/getters';
import Filter from '@/models/Filter';

@Component({
  name: 'filters-component',
  components: { FilterBlockComponent },
})
export default class FiltersComponent extends Vue {
  private filters: Array<Filter> = [];

  private get allFilters(): Array<Filter> {
    return this.filters;
  }

  private get filterMap(): Map<string, Filter> {
    return this.$store.getters[FilterGetter.Filters];
  }

  @Watch('filterMap')
  private updateLocalFilters(newValue: Map<string, Filter>) {
    this.filters = [...newValue.values()];
  }
}
